/**
 * 工单统计概况
 */
import { WORKORDEROVERVIEW } from '../types';

export default {
    name: `${WORKORDEROVERVIEW}`,
    path: '/workOrderOverview',
    component: () => import(/* webpackChunkName: 'workOrderStatistics' */ '@/views/workOrderStatistics/'),
    redirect: { name: `${WORKORDEROVERVIEW}Index` },
    meta: {
        title: '统计概况',
        savedPosition: { x: 0, y: 0 },
        noCache: true,
    },
    children: [
        {
            name: `${WORKORDEROVERVIEW}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'workOrderStatisticsIndex' */ '@/views/workOrderStatistics/home/Home.vue'),
        },
    ],
};
